/**
 * 站点页脚 —— 首页与内容页共用。法务链接与 ICP 备案号在这里(而非顶部
 * 导航),因此每一页都带备案号。
 */
import { appUrl } from '@web-v4/router-utils';
import { SHANGHAI_OFFSET_MS } from '../lib/index-time';

export function SiteFooter() {
  const year = new Date(Date.now() + SHANGHAI_OFFSET_MS).getUTCFullYear();

  return (
    <footer className="wv-h2-footer">
      <span>
        © {year} <a href={appUrl('portal')}>随便MC</a>
      </span>
      <span>
        官方 QQ 群 <strong>392455229</strong>
      </span>
      <span>
        <a href={appUrl('portal', '/terms')}>服务条款</a>
      </span>
      <span>
        <a href={appUrl('portal', '/privacy')}>隐私协议</a>
      </span>
      <span>
        <a href="http://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
          京ICP备18035465号
        </a>
      </span>
    </footer>
  );
}
